import React from 'react';
import PropTypes from 'prop-types';

import { srSubstitute } from '../utilities/ui/mask-string';

export default function VAFileNumberWidget({ value }) {
  if (value && (value.length === 8 || value.length === 9)) {
    const lastFour = value.slice(-4);
    return value.length === 9 ? (
      <span className="dd-privacy-hidden" data-dd-action-name="VA file number">
        {srSubstitute(
          `●●●●●${lastFour}`,
          `ending with ${lastFour.split('').join(' ')}`,
        )}
      </span>
    ) : (
      <span className="dd-privacy-hidden" data-dd-action-name="VA file number">
        {srSubstitute(
          `●●●●${lastFour}`,
          `ending with ${lastFour.split('').join(' ')}`,
        )}
      </span>
    );
  }

  return (
    <span className="dd-privacy-hidden" data-dd-action-name="VA file number">
      {value}
    </span>
  );
}

VAFileNumberWidget.propTypes = {
  value: PropTypes.string,
};
